import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { useData } from '../../../contexts';
import { EvolutiescoreTable } from './EvolutiescoreTable';
import { MdHelpOutline } from 'react-icons/md';
import { Tooltip, TooltipTrigger, TooltipContent } from '../../Tooltip/Tooltip';
import { InfoPanel } from '../../InfoPanel/InfoPanel';
import { DownloadButton } from '../../DownloadButton/DownloadButton';
import { BarChartDelta, BarChartComparisson } from '../../BarChart/BarChart';

export const Indexscore = (props: any) => {
  const { data, clickHandler, allIndicators, interactieveToolPath } = props;
  const {
    tableWidth,
    interfaceColor,
    indexColors,
    selectedGemeente,
    selectedBenchmarks,
    selectedTopic,
    locale,
    deltaColors,
  } = useData();

  const id = 'indexScoreSurvey';

  const [keysInStack, setKeysInStack] = useState(['value', 'valueBench']);
  const [colorsBar, setColorsBar] = useState(indexColors);

  return (
    <Grid container style={{ padding: '16px' }}>
      <Grid item xs={12}>
        <div
          className={'vl-typography'}
          style={{ paddingLeft: '8rem', float: 'left', width: '70%' }}
        >
          <h4 className="page-title">
            Hoe scoort {selectedGemeente.label} ten opzichte van de benchmark{' '}
            {selectedBenchmarks[0].label}?{' '}
            <Tooltip>
              <TooltipTrigger
                style={{
                  width: '30px',
                  top: '4px',
                  position: 'relative',
                  display: 'inline',
                }}
              >
                <MdHelpOutline
                  style={{
                    cursor: 'pointer',
                    fontSize: '24px',
                    color: interfaceColor,
                  }}
                />
              </TooltipTrigger>
              <TooltipContent className="Tooltip">
                <p>
                  In de linkse grafiek tonen we per indicator het percentage van{' '}
                  {selectedGemeente.label} en{' '}
                  {selectedBenchmarks[0].label === 'Vlaams Gewest'
                    ? 'het Vlaams Gewest'
                    : selectedBenchmarks[0].label}
                  .
                </p>
                <p>
                  In de rechtse grafiek brengen we het absoluut verschil
                  uitgedrukt in procentpunten in beeld.
                </p>
                <p>
                  De indicatoren zijn gerangschikt op basis van het afnemend
                  verschil met de benchmark.
                </p>
                <br />
                <p>
                  In de interactieve toepassing vind je alle surveyindicatoren
                  terug per thema.
                </p>
                <p>
                  Via de knop 'Meer informatie' kan je per indicator meteen naar
                  de interactieve toepassing gaan.
                </p>
                {/* <p>
                  In de linkse grafiek tonen we per indicator het percentage
                  voor {selectedGemeente.label} en voor{' '}
                  {selectedBenchmarks[0].label === 'Vlaams Gewest'
                    ? 'het Vlaams Gewest'
                    : selectedBenchmarks[0].label}
                  .
                </p>
                <br />
                <p>In de tooltip geven we nog twee waarden mee: </p>
                <br />
                <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                  <li>
                    Absoluut verschil: hoeveel procentpunten ligt de waarde van{' '}
                    {selectedGemeente.label} hoger of lager dan die van{' '}
                    {selectedBenchmarks[0].label === 'Vlaams Gewest'
                      ? 'het Vlaams Gewest'
                      : selectedBenchmarks[0].label}
                    ?
                    <br />
                    De berekening is als volgt: {selectedGemeente.label} (
                    {data.length > 0 && data[0].jaar}) -{' '}
                    {selectedBenchmarks[0].label === 'Vlaams Gewest'
                      ? 'het Vlaams Gewest'
                      : selectedBenchmarks[0].label}{' '}
                    ({data.length > 0 && data[0].jaar}).
                  </li>
                  <li>
                    Relatief verschil: hoe sterk wijkt de waarde van{' '}
                    {selectedGemeente.label}, relatief gezien, af van die van{' '}
                    {selectedBenchmarks[0].label === 'Vlaams Gewest'
                      ? 'het Vlaams Gewest'
                      : selectedBenchmarks[0].label}
                    , in positieve of negatieve zin? <br />
                    De berekening is als volgt: ( {selectedGemeente.label} (
                    {data.length > 0 && data[0].jaar}) -{' '}
                    {selectedBenchmarks[0].label === 'Vlaams Gewest'
                      ? 'het Vlaams Gewest'
                      : selectedBenchmarks[0].label}{' '}
                    ({data.length > 0 && data[0].jaar}) ) /{' '}
                    {selectedBenchmarks[0].label === 'Vlaams Gewest'
                      ? 'het Vlaams Gewest'
                      : selectedBenchmarks[0].label}{' '}
                    ({data.length > 0 && data[0].jaar}).
                  </li>
                </ul>
                <br />
                <p>
                  In de rechtse grafiek brengen we het relatieve positieve of
                  negatieve verschil in beeld. Dit laat toe om het verschil over
                  indicatoren heen in perspectief te plaatsen. Zo kan je snel
                  over indicatoren heen vergelijken.
                </p>{' '}
                <br />
                <p>
                  De indicatoren zijn gesorteerd van grootste positief verschil
                  naar grootste negatief verschil.
                </p> */}
              </TooltipContent>
            </Tooltip>
          </h4>
          <p className="page-subtitle">
            Op welke indicatoren uit de kernset van de burgerbevraging voor het
            thema {selectedTopic.thema} scoort {selectedGemeente.label} hoger of
            lager dan de benchmark {selectedBenchmarks[0].label}?
          </p>
        </div>
        <div
          className={'vl-typography'}
          style={{
            float: 'right',
            // marginLeft: 'auto',
            marginRight: '36px',
            cursor: 'pointer',
            paddingRight: '8px',
            paddingLeft: '8px',
            backgroundColor: interfaceColor,
            borderRadius: 12,
            position: 'relative',
            top: '18px',
          }}
        >
          <p onClick={clickHandler} style={{ marginBottom: 0, color: 'white' }}>
            Pas je selectie aan
          </p>
        </div>

        {data !== undefined && data.length > 0 && (
          <DownloadButton id={id} name={`${id}_${selectedTopic.thema}`} />
        )}

        <InfoPanel
          allIndicators={allIndicators}
          data={data}
          interactieveToolPath={interactieveToolPath}
        />
      </Grid>

      <Grid
        item
        xs={12}
        pl={5}
        pr={5}
        height={'80vh'}
        minHeight={'400px'}
        maxHeight={'80vh'}
        id={id}
        sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}
      >
        {data !== undefined && data.length > 0 ? (
          <Grid container sx={{ maxHeight: '100%' }}>
            <Grid
              item
              xs={8}
              sx={{ height: data.length * 52 + 86, maxHeight: '66vh' }}
            >
              <h5 style={{ textAlign: 'center' }}>
                <span style={{ color: colorsBar[0] }}>{data[0].gemeente}</span>{' '}
                versus{' '}
                <span style={{ color: colorsBar[1] }}>{data[0].bench}</span>
              </h5>
              <BarChartComparisson
                data={data}
                keysInStack={keysInStack}
                colors={colorsBar}
                locale={locale}
                survey={data?.detail?.survey === '0' ? false : true}
                legend={false}
                labels={[data[0].gemeente, data[0].bench]}
              />
            </Grid>
            <Grid
              item
              xs={4}
              sx={{ height: data.length * 52 + 86, maxHeight: '66vh' }}
            >
              <h5 style={{ textAlign: 'center' }}>
                <span style={{ color: deltaColors[1] }}>Lager</span> of{' '}
                <span style={{ color: deltaColors[0] }}>hoger</span> dan de
                benchmark
                {/* {selectedBenchmarks[0].label === 'Vlaams Gewest'
                  ? 'het Vlaams Gewest'
                  : selectedBenchmarks[0].label} */}
              </h5>
              <BarChartDelta data={data} colors={deltaColors} locale={locale} />
            </Grid>
          </Grid>
        ) : (
          <p>Geen data gevonden</p>
        )}
      </Grid>
    </Grid>
  );
};
